import React from 'react';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { Spacer } from 'app/member/layouts/generic';
import { DetailItem } from 'app/shared/info-section/item';
import { formatDateForDisplay } from 'app/shared/utils/date';

export const SubscriptionDetail = ({ subscription = {} }) => {
  const tenant = subscription.tenant || {};

  return (
    <>
      <GridRow num_of_columns={2}>
        <GridColumn>
          <DetailItem title="Subscription">
            {subscription.title || subscription.plan_code || '—'}
          </DetailItem>
        </GridColumn>
        <GridColumn>
          <DetailItem title="Amount">
            {subscription.price
              ? `${subscription.price.amount} ${subscription.price.currency?.code || ''}`
              : '—'}
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Expiration Date">
            {formatDateForDisplay(subscription.expires_at) || '—'}
          </DetailItem>
        </GridColumn>
      </GridRow>

      <Spacer multiple={4} />

      <GridRow num_of_columns={2}>
        <GridColumn>
          <DetailItem title="Tenant">{tenant.name || '—'}</DetailItem>
        </GridColumn>
        <GridColumn>
          <DetailItem title="Email">{tenant.emails?.[0] || tenant.email || '—'}</DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Phone">{tenant.phone_number || '—'}</DetailItem>
        </GridColumn>
      </GridRow>
    </>
  );
};
